import React from "react"
import { Link, useStaticQuery, graphql } from "gatsby"
import GenerateBlogList from "../components/bloglist"

const RecentBlogBlob = () => {
  const data = useStaticQuery(graphql`
    query recentBlogListQuery {
        allSitePage(
          sort: { fields: context___date, order: DESC }
          filter: { context: { date: {ne: null}, parent: { eq: "/blog" } } }
          limit: 5
        ) {
          edges {
            node {
              id
              path
              context {
                id
                name
                parent
                title
                type
                depth
                date
                excerpt
              }
            }
          }
        }
      }
  `)

  return (<GenerateBlogList edges={data.allSitePage.edges} summary={false} date={false} />)
}

export default RecentBlogBlob 